<template>
  <ElectricityHome />
</template>

<script>
import ElectricityHome from "../electricity/index.vue";

export default {
  name: "CockpitWater",
  components: {
    ElectricityHome,
  },
};
</script>
